import { api, config } from '../../../helpers/api';

export async function sendFeedbackRequest({ receiverId, message, title }) {
  return await api.post(
    '/feedback_request/',
    {
      receiver_id: receiverId,
      message: message,
      title: title
    },
    config('json')
  );
}

export async function uploadFeedbackRequestAttachment(feedbackRequestId, file) {
  const formData = new FormData();
  formData.append('file', file);

  return await api.post(
    `/feedback_request/${feedbackRequestId}/media`,
    formData,
    config('form')
  );
}
